<template>
  <li class="divider"></li>
</template>

<script>
export default {
  name: "list-divider"
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Dropdown/ListDivider.vue